
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 30 30"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"stroke-width":"1.6","d":"M5 27.19V2.81h15l5 5v19.38H5z"}}),_c('g',{attrs:{"stroke-width":"1.2"}},[_c('path',{attrs:{"d":"M10 12.5l1.88 8.75L15 12.5l3.13 8.75L20 12.5M8.75 12.5h2.5M21.25 12.5h-2.5"}})])])])
          )
        }
      }
    